import { inject } from 'vue';
import type { Component, InjectionKey } from 'vue';

/**
 * The link component the design system renders for in-app (SPA) navigation.
 *
 * The design system is framework-agnostic — it never imports the host app's
 * router. The host provides its link component ONCE at the root (Inertia's
 * `<Link>`, vue-router's `RouterLink`, …) under this key; design-system
 * components inject it via {@link useDesignSystemLink}.
 *
 * When nothing is provided (Storybook, component tests, any standalone render)
 * it falls back to a plain `<a>` — the correct degradation where there is no
 * router to navigate with. The host wires the real link in `resources/js/app.js`.
 */
export const DesignSystemLinkKey: InjectionKey<Component | string> = Symbol('design-system-link');

/** The host-provided link component, or `'a'` when rendered standalone. */
export function useDesignSystemLink(): Component | string {
    return inject(DesignSystemLinkKey, 'a');
}
